// Site entity manifest: compact create Form plus the card shared by the tenant app and portals.
import { ActivityEntityName, CrmSecurityRight, DomainType, SitePro, SurfaceType } from '@jms/model';
import { RightsService } from '@jms/utils/util.permissions';
import type { EntityManifestCard } from '@workbuddy/services/entities/entity.manifest';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';

const card: EntityManifestCard<SitePro> = { component: () => import('./entity.card.renderer/site.entity.card.renderer.component').then(module => module.SiteEntityCardRendererComponent), resolution: 'if-needed', isComplete: value => !!(value.address?.street1 || value.address?.street2 || value.address?.suburb || value.address?.lat), summarize: value => ({ title: value.name ?? 'Not set' }) };

export const siteManifest = registerManifest<SitePro>({
  entity: ActivityEntityName.SitePro,
  slug: 'site',
  presentation: { card },
  domains: {
    [DomainType.ClientPortal]: { presentation: { card } },
    [DomainType.ContractorPortal]: { presentation: { card } },
  },
  surfaces: {
    [SurfaceType.Form]: () => import('./surface/create/site.create.surface').then(module => module.siteCreateFormSurface),
  },
  operations: {
    create: {
      surface: SurfaceType.Form,
      presentation: { mode: 'dialog', width: 'min(520px, calc(100vw - 40px))' },
      authorize: ({ injector }) => injector.get(RightsService).hasRights(CrmSecurityRight.ManageSites),
    },
  },
  relations: {
    [ActivityEntityName.VisitApproval]: () => import('./relations/site.visit.approvals.relation').then(module => module.siteVisitApprovalsBoardBuilder),
  },
});
